<template>
<v-container v-if="players">
  <div class="resumen_tournament">
    <v-row>
      <v-col>
    <div class="pt-3"> Arbitros </div>
      </v-col>
    </v-row>
    <v-row>
    <v-col>
      <div style="font-size: 15px; text-decoration: underline"><p>El listado esta en contruccion sino esta en el listado envie un email a chantez@hotmail.es</p></div>
    </v-col>
  </v-row>
  </div>
<div>
  <br>
      <v-row
        no-gutters
      >
        <v-col cols="8" md="4">
          <v-select
              v-model="category_selected"
              :items="categories"
              label="Selecciona Categoria"
            ></v-select>
        </v-col>

      </v-row>
<br>
  <v-table density="compact">
    <thead>
      <tr>
        <th class="text-center">
          Nombre
        </th>
        <th class="text-center">
          ID
        </th>
        <th class="text-center">
          Tipo
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in players"
        :key="item.id"
      >
        <td class="text-left" style="width: 800px"><a :href="'/player/'+item.id" style="color:blue">{{ item.person.full_name }}</a></td>
        <td class="text-left">
            {{ item.person.federation_id }}
        </td>
        <td class="text-left">
          {{item.sub_classification.name}}
        </td>
      </tr>
    </tbody>
  </v-table>
  </div>
</v-container>

</template>
<script>
  import gql from "graphql-tag";
  import { vue3Debounce } from 'vue-debounce'
  import {mapState} from "vuex";
  export default {
    directives: {
    debounce: vue3Debounce({ lock: true })
  },
    apollo: {
    data_response: {query: gql` query($id:String!){
       arbitrers(id:$id){
        sub_classification:subClassification{
          name
        }
        person {
          full_name:fullName
          federation_id:federationId
        }
      }
      categories_arbitrers:categoriesArbitrers {
        value:id
        title:name
      },
    }`,
      variables() {return {"id" :this.category_selected+""}},
      update(data) {
      console.log("acaa en data",data)
        this.players = data.arbitrers
        this.categories = data.categories_arbitrers;
    }
    },
  },
    name:"SeeArbitrers",
    data () {
      return {
        players:null,
        categories:[],
        category_selected: "",
      }
    },
    computed: {
    ...mapState(['is_authenticated']),
  },
    methods: {
    performSearchFirstName(newVal,type ) {
      console.log('debounced', newVal, type)
      this.first_name_net = newVal;
    },
    performSearchLastName(newVal,type ) {
      console.log('debounced', newVal, type)
      this.last_name_net = newVal;
    },
      performSearchLastSecondName(newVal,type ) {
      console.log('debounced', newVal, type)
      this.last_name_second_net = newVal;
    },

  },
  }
</script>

